import { useCallback } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { useInstallCompatibility } from '../hooks/useInstallCompatibility';
import { CompatibilityModal } from './CompatibilityModal';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeatureCompatibilityModal({
  features,
  onClose,
  listingId
}) {
  const {
    appContext,
    productType,
    trackInteraction,
    published
  } = useDetailsPageContext();

  // Use the new CHIRP hook to get install compatibility data
  const {
    data: installCompatibilityData
  } = useInstallCompatibility({
    appContext,
    listingId,
    published
  });
  const productInstallCompatibility = installCompatibilityData === null || installCompatibilityData === void 0 ? void 0 : installCompatibilityData.productInstallCompatibility;

  // Filter features to only include those with featureLocation "MARKETPLACE_LISTING"
  const marketplaceListingFeatures = features.filter(feature => {
    var _feature$featureLocat;
    return (_feature$featureLocat = feature.featureLocation) === null || _feature$featureLocat === void 0 ? void 0 : _feature$featureLocat.includes('MARKETPLACE_LISTING');
  });
  const featuresWithTierCompatibility = marketplaceListingFeatures.map(feature => {
    var _productInstallCompat;
    // Find the compatibility data for this feature by matching feature names
    const featureCompatibility = productInstallCompatibility === null || productInstallCompatibility === void 0 || (_productInstallCompat = productInstallCompatibility.featureCompatibilities) === null || _productInstallCompat === void 0 ? void 0 : _productInstallCompat.find(compat => compat.featureName === feature.featureName);

    // For the new structure, the compatible tiers are directly available
    // Convert from CHIRP Default<Tier[]> to TierType[] (they have the same string values)
    const compatibleTiers = (featureCompatibility === null || featureCompatibility === void 0 ? void 0 : featureCompatibility.compatibleTiers) || [];
    return {
      text: feature.featureName,
      tiers: compatibleTiers
    };
  });
  const handleTrackInteraction = useCallback(eventProps => {
    trackInteraction(Object.assign({
      section: 'feature compatibility modal'
    }, eventProps));
  }, [trackInteraction]);
  return /*#__PURE__*/_jsx(CompatibilityModal, {
    appContext: appContext === 'app' ? 'app' : 'public',
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    onClose: onClose,
    portalTiers: (productInstallCompatibility === null || productInstallCompatibility === void 0 ? void 0 : productInstallCompatibility.portalTiers) || [],
    productType: productType,
    onTrackInteraction: handleTrackInteraction
  });
}